import { ERoleType } from '@/types/enums'
import { routeNames } from '@/router/route-names'

class AuthService {
  defaultRolesRoute = {
    [ERoleType.spencerAdmin]: routeNames.spencerAdmin,
    [ERoleType.schoolAdmin]: routeNames.schoolAdmin,
    [ERoleType.needManager]: routeNames.needManager,
    [ERoleType.professional]: routeNames.professional
  }

  // This function should be invoked with check if user exist in parent context
  getDefaultRoleRoute () {
    const authStore = useAuthStore()

    const redirectRouteName = authStore.user && this.defaultRolesRoute[authStore.user.role]

    return { name: redirectRouteName || routeNames.settingsProfile }
  }

  getMe () {
    return useHttp.get('/api/me/')
      .then(res => {
        // Override generic schoolStaff role and have only specific school roles for schoolStaff
        const role = res.systemRole === 'schoolStaff' ? res.schools?.[0]?.role || ERoleType.schoolAdmin : res.systemRole

        return {
          ...res, systemRole: role
        }
      })
  }

  setPassword (payload: ISetPasswordPayload, reset = false) {
    const authStore = useAuthStore()
    const path = reset ? '/api/auth/reset-password' : '/api/auth/password'
    const normalizedPayload = { ...payload, email: payload.email.toLowerCase() }

    return useHttp.post(path, normalizedPayload)
      .then(() => {
        if (!reset) { return authStore.handleSignIn({ email: normalizedPayload.email, password: normalizedPayload.password }) }
      })
  }

  sendRecoveryLink (email: string) {
    return useHttp.post('/api/auth/send-reset-password-email', { email: email.toLowerCase() })
  }
}

export const authService = new AuthService()
